import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IDevice } from 'src/app/interface/device';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class DeviceService {

	constructor(private httpClient: HttpClient) { }

	public store(data: IDevice): Observable<any> {
		return this.httpClient.post<any>(
			environment.apiUrl + '/{current_company_id}/device/store', data
		);
	}

	public delete(data: IDevice): Observable<any> {
		let params = new HttpParams();
		if (data.token) {
			params = params.append('token', data.token.toString());
		}
		if (data.uuid) {
			params = params.append('uuid', data.uuid.toString());
		}
		return this.httpClient.delete<any>(environment.apiUrl + '/{current_company_id}/device/destroy', { params });
	}
}
